import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ORDER_HISTORY_SERVICE_URL } from 'src/app/injection-tokens';
import { AuthService } from 'src/app/auth/auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderHistoryService {
  constructor(
    @Inject(ORDER_HISTORY_SERVICE_URL) readonly orderHistoryServiceURL: string,
    private authService: AuthService,
    readonly http: HttpClient
  ) {}

  rejectCancellation(customerNumber: string, orderNumber: string, orderPosNumber: string): Observable<null> {
    return this.http.put<null>(
      `${this.orderHistoryServiceURL}internal/orderhistory/cancellations/${customerNumber}/${orderNumber}/${orderPosNumber}`,
      {
        status: 'REJECTED',
        updatedByHint: this.authService.getUserInfo().fullName,
      }
    );
  }
}
